/**
 * 클라이언트 페이징 산술.
 *
 * EVER TV 관리자 목록은 BE 가 Spring Page 가 아니라 plain array 로 내려주고, 카테고리 필터도
 * 화면에서 건다. 그래서 "현재 페이지" 가 **목록보다 뒤에 남는** 상황이 실제로 생긴다 —
 * 3페이지를 보다 필터를 걸거나 영상을 지우면 결과가 1페이지 분량으로 줄어든다. 그때 슬라이스가
 * 빈 배열이 되어 **데이터는 있는데 표만 비는** 화면이 된다.
 *
 * 그래서 자르기 전에 항상 페이지 번호를 범위 안으로 좁힌다. 컴포넌트에 인라인으로 두면 이
 * 경계가 테스트 없이 굳는다.
 */

/** 전체 건수에 대한 페이지 수. 0건이어도 1페이지로 본다(빈 목록도 1/1 로 표기). */
export const pageCount = (total: number, size: number): number =>
  Math.max(1, Math.ceil(Math.max(0, total) / Math.max(1, size)));

/** 페이지 번호를 1 ~ 마지막 페이지 사이로 좁힌다. 숫자가 아니면 1. */
export const clampPage = (page: number, total: number, size: number): number => {
  if (!Number.isFinite(page)) return 1;
  return Math.min(Math.max(Math.trunc(page), 1), pageCount(total, size));
};

/** 해당 페이지의 행들. 페이지 번호는 내부에서 좁히므로 호출부가 따로 방어하지 않아도 된다. */
export const pageSlice = <T>(rows: ReadonlyArray<T>, page: number, size: number): T[] => {
  const safe = clampPage(page, rows.length, size);
  const start = (safe - 1) * size;
  return rows.slice(start, start + size);
};
